import * as Types from './Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';
import Project from 'src/entities/Project';

export interface UpdateProjectAttempt extends Action {
  type: Types.UPDATE_PROJECT_ATTEMPT;
}

export interface UpdateProjectSuccess extends Action {
  type: Types.UPDATE_PROJECT_SUCCESS;
}

export interface UpdateProjectFailure extends Action {
  type: Types.UPDATE_PROJECT_FAILURE;
  payload: {};
}

export type UpdateProjectAction =
  UpdateProjectAttempt |
  UpdateProjectSuccess |
  UpdateProjectFailure;

export interface UpdateProjectThunk extends ThunkAction<Promise<UpdateProjectAction>, RootState, null> {
}

export const updateProjectAttempt: ActionCreator<UpdateProjectAttempt> = () => (
  { type: Types.UPDATE_PROJECT_ATTEMPT }
);

export const updateProjectSuccess: ActionCreator<UpdateProjectSuccess> = () => (
  {
    type: Types.UPDATE_PROJECT_SUCCESS,
  }
);

export const updateProjectFailure: ActionCreator<UpdateProjectFailure> = (error: {}) => (
  {
    type: Types.UPDATE_PROJECT_FAILURE,
    payload: error
  }
);

export const updateProject: ActionCreator<UpdateProjectThunk> = (
  project: Project
): UpdateProjectThunk => {

  return (dispatch: Dispatch<RootState>): Promise<UpdateProjectAction> => {

    dispatch(updateProjectAttempt());

    return ApiClient.project.update(project.id, project)
      .then((response: AxiosResponse): UpdateProjectSuccess => {
        return dispatch(updateProjectSuccess());
      }).catch((e: { response: { data: { errors: {} } } }): UpdateProjectFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.errors);

        return dispatch(updateProjectFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/project/update/UpdateProject.actions.tsx